import React from 'react';
import { useLiteWebView } from '@/hooks/useDefaultLiteWebView';
import { DesktopFooter } from '@/components/Footer/DesktopFooter';
import { BusinessPageCustom } from '@/components/Business/BusinessPageCustom';
import useScreenSize from '@/hooks/useScreenSize';
import { Footer } from '@/components/Footer/Footer';
import { Header } from '@/components/Header';
import { PageTopControls } from '@/components/PageTopControls';
import { PackagesListData } from '@/api/types/business.types';

interface Props {
  isLite?: boolean;
  packagesListData?: PackagesListData | null;
}

export const BusinessLandingPageView: React.FC<Props> = ({
  isLite: isLiteProp,
  packagesListData,
}) => {
  const { isLarge } = useScreenSize();
  const isLiteClient = useLiteWebView();
  const isLite = typeof isLiteProp !== 'undefined' ? isLiteProp : isLiteClient;

  return (
    <>
      {!isLite && (
        <PageTopControls>
          <Header hasBurger />
        </PageTopControls>
      )}

      <BusinessPageCustom packagesListData={packagesListData} />

      {!isLite && (isLarge ? <DesktopFooter /> : <Footer isBusinessPage />)}
    </>
  );
};
